function warnCacheFailure(message) {
  console.warn(message);
}

function hasExactKeys(value, keys) {
  return value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value).length === keys.length &&
    keys.every(key => Object.prototype.hasOwnProperty.call(value, key));
}

function isValidEnvelope(cache, version, isValidData) {
  return hasExactKeys(cache, ['version', 'expiresAt', 'data']) &&
    cache.version === version &&
    Number.isFinite(cache.expiresAt) &&
    isValidData(cache.data);
}

export function removeSessionStorageCache(cacheKey, warningMessage) {
  try {
    window.sessionStorage.removeItem(cacheKey);
  } catch (error) {
    warnCacheFailure(warningMessage);
  }
}

export function readSessionStorageCache({ cacheKey, version, isValidData, warningMessage }) {
  let serializedCache;
  try {
    serializedCache = window.sessionStorage.getItem(cacheKey);
  } catch (error) {
    warnCacheFailure(warningMessage);
    return null;
  }

  if (serializedCache === null) return null;

  let cache;
  try {
    cache = JSON.parse(serializedCache);
  } catch (error) {
    removeSessionStorageCache(cacheKey, warningMessage);
    warnCacheFailure(warningMessage);
    return null;
  }

  if (!isValidEnvelope(cache, version, isValidData)) {
    removeSessionStorageCache(cacheKey, warningMessage);
    warnCacheFailure(warningMessage);
    return null;
  }

  if (cache.expiresAt <= Date.now()) {
    removeSessionStorageCache(cacheKey, warningMessage);
    return null;
  }

  return cache.data;
}

export function writeSessionStorageCache({ cacheKey, version, ttlMs, data, warningMessage }) {
  try {
    window.sessionStorage.setItem(cacheKey, JSON.stringify({
      version,
      expiresAt: Date.now() + ttlMs,
      data,
    }));
  } catch (error) {
    warnCacheFailure(warningMessage);
  }
}
